import React, { useRef, useState } from "react";
import { Container, Paper, Typography, Button, Box } from "@mui/material";
import { format, endOfMonth } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { exportDatabaseDump } from "./services";
import { toast, ToastContainer } from "react-toastify";

// Main App Component
const DownloadDatabase = () => {
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [selectRange, setSelectedRange] = useState([]);
  const ref = useRef();

  // Function to handle the download button click
  const handleDownload = async () => {
    if (startDate && endDate) {
      const formattedStartDate = format(startDate, "yyyy-MM-dd");
      const lastDayOfEndMonth = endOfMonth(endDate);
      const formattedEndDate = format(lastDayOfEndMonth, "yyyy-MM-dd");

      const data = {
        start_date: formattedStartDate,
        end_date: formattedEndDate,
      };
      try {
        const response = await exportDatabaseDump(data);
        if (response.data.success == true) {
          toast.success(response.data.message);
        }
      } catch (error) {
        console.log(error);
        toast.error(error.response.data.message);
      }
    }
  };

  const handleSelectDateRange = (start, end) => {
    const months = [];
    let currentMonth = start.getMonth();
    let currentYear = start.getFullYear();
    const endMonth = end.getMonth();
    const endYear = end.getFullYear();

    while (
      currentYear < endYear ||
      (currentYear === endYear && currentMonth <= endMonth)
    ) {
      const date = new Date(currentYear, currentMonth);
      const monthString = date.toLocaleString("default", { month: "short" });
      const yearString = date.toLocaleString("default", { year: "numeric" });
      const label = `${monthString}-${yearString}`;
      months.push({ id: currentMonth, label: label });
      currentMonth++;
      if (currentMonth > 11) {
        currentMonth = 0;
        currentYear++;
      }
    }
    setSelectedRange(months);
  };

  return (
    <>
    <ToastContainer />
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#f0f2f5",
        padding: "2rem",
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            p: 4,
            borderRadius: "16px",
            textAlign: "center",
            backgroundColor: "#ffffff",
          }}
        >
          <Typography
            variant="h4"
            component="h1"
            gutterBottom
            sx={{
              fontWeight: "bold",
              color: "#1a237e",
              marginBottom: "2rem",
            }}
          >
            Download Database Excel
          </Typography>
            <h6 style={{marginLeft:"53px", textAlign:"left"}}>Choose the month:</h6>
          <Box
            sx={{
              display: "flex",
              gap: "1rem",
              marginBottom: "2rem",
              justifyContent: "center",
            }}
          >
            <Box>
              <DatePicker
                selected={startDate}
                onChange={(date) => {
                  setStartDate(date);
                  if (endDate) {
                    handleSelectDateRange(date, endDate);
                  }
                }}
                dateFormat="MMM y"
                className="analytics-date-picker"
                placeholderText="Start Month"
                showMonthYearPicker
                ref={ref}
              />
            </Box>
            <Box>
              <DatePicker
                selected={endDate}
                onChange={(date) => {
                  setEndDate(date);
                  if (startDate) {
                    handleSelectDateRange(startDate, date);
                  }
                }}
                dateFormat="MMM y"
                className="analytics-date-picker"
                placeholderText="End Month"
                showMonthYearPicker
                ref={ref}
              />
            </Box>
          </Box>

          <Button
            variant="contained"
            onClick={handleDownload}
            sx={{
              mt: 2,
              px: 4,
              py: 1.5,
              marginLeft: "auto",
              marginRight: "auto",
              fontSize: "1rem",
              fontWeight: "bold",
              backgroundColor: "#1a237e",
              textTransform: "none",
            }}
          >
            Download
          </Button>
        </Paper>
      </Container>
    </Box>
    </>
  );
};

export default DownloadDatabase;
